import { useEffect } from 'react';

const useChatEventListeners = ({
  isChatWindowOpen,
  toggleChatWindow,
  sofabuddyThreadId,
  amplitudeTracking,
  messageSent,
  setMessageSent,
  initializeChat
}) => {
  useEffect(() => {
    const handleClickOutside = event => {
      const chatWindow = document.querySelector('.rcb-chat-window');
      if (
        isChatWindowOpen &&
        chatWindow &&
        !chatWindow.contains(event.target)
      ) {
        toggleChatWindow();
        amplitudeTracking('sofabuddy_chat_ended');
      }
    };

    window.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isChatWindowOpen, amplitudeTracking]);

  useEffect(() => {
    const handleLoadChatHistory = () => {
      if (!sofabuddyThreadId) {
        amplitudeTracking('sofabuddy_past_history_clicked');
      }
    };

    window.addEventListener('rcb-load-chat-history', handleLoadChatHistory);
    return () => {
      window.removeEventListener(
        'rcb-load-chat-history',
        handleLoadChatHistory
      );
    };
  }, [sofabuddyThreadId, amplitudeTracking]);

  useEffect(() => {
    const handleUserSubmitText = () => {
      if (!messageSent) {
        amplitudeTracking('sofabuddy_chat_started');
        setMessageSent(true);
      }
    };

    window.addEventListener('rcb-user-submit-text', handleUserSubmitText);
    return () => {
      window.removeEventListener('rcb-user-submit-text', handleUserSubmitText);
    };
  }, [messageSent, amplitudeTracking]);

  useEffect(() => {
    const handleToggleChatWindow = () => {
      if (isChatWindowOpen) {
        amplitudeTracking('sofabuddy_chat_ended');
      } else {
        amplitudeTracking('sofabuddy_clicked');
      }
    };

    window.addEventListener('rcb-toggle-chat-window', handleToggleChatWindow);
    return () => {
      window.removeEventListener(
        'rcb-toggle-chat-window',
        handleToggleChatWindow
      );
    };
  }, [amplitudeTracking, isChatWindowOpen]);

  useEffect(() => {
    const handleSofabuddyCardClick = () => {
      if (!isChatWindowOpen) {
        toggleChatWindow();
        initializeChat();
      }
    };

    window.addEventListener('rcb-card-click', handleSofabuddyCardClick);
    return () => {
      window.removeEventListener('rcb-card-click', handleSofabuddyCardClick);
    };
  }, [isChatWindowOpen, toggleChatWindow]);
};

export default useChatEventListeners;
